/**
 * @generated SignedSource<<1f995cf3522335b726ca419677af4fe1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontOnly_item$data = {
  readonly isStorefrontOnly: boolean | null;
  readonly " $fragmentType": "StorefrontOnly_item";
};
export type StorefrontOnly_item$key = {
  readonly " $data"?: StorefrontOnly_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontOnly_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontOnly_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isStorefrontOnly",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bd19f05b83da40587f7adf343ba3b6ff";

export default node;
